import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Collapse } from 'reactstrap';
import withRouter from 'Components/Common/withRouter';
import navdata from 'Layouts/LayoutMenuData';
import { withTranslation } from 'react-i18next';
import styles from './HorizontalLayout.module.css';

const paddingAndMarginStyle = 'px-2 mx-2';
const paddingAndMarginHeaderStyle = 'px-2 mx-2';

const HorizontalLayout = (props: any) => {
  const [isMoreMenu, setIsMoreMenu] = useState<boolean>(false);
  const [menuSplitContainer, setMenuSplitContainer] = useState<number>(9);

  // Update `menuSplitContainer` based on screen width
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1025 && window.innerWidth <= 1250) {
        setMenuSplitContainer(6);
      } else {
        setMenuSplitContainer(9);
      }
    };

    // Initial setup and event listener for window resizing
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const navData = navdata().props.children;
  // const navData = useMemo(() => navdata().props.children, []);

  // const menuItems: Array<any> = [];
  // const splitMenuItems: Array<any> = [];

  // Separate main items and overflow items based on `menuSplitContainer`
  // navData.forEach((value: any, key: number) => {
  //   if (value['is_header']) {
  //     setMenuSplitContainer((prev) => prev + 1);
  //   }
  //   if (key >= menuSplitContainer) {
  //     const val = {
  //       ...value,
  //       child_items: value.sub_items,
  //       is_child_item: !!value.sub_items,
  //     };
  //     splitMenuItems.push(val);
  //   } else {
  //     menuItems.push(value);
  //   }
  // });

  // Add "More" menu only when `menuSplitContainer` is `6`
  // if (menuSplitContainer === 6 && splitMenuItems.length > 0) {
  //   menuItems.push({
  //     id: 'more',
  //     label: 'More',
  //     icon: 'ri-briefcase-2-line',
  //     link: '/#',
  //     stateVariables: isMoreMenu,
  //     sub_items: splitMenuItems,
  //     click: (e: any) => {
  //       e.preventDefault();
  //       setIsMoreMenu(!isMoreMenu);
  //     },
  //   });
  // }

  const { menuItems } = useMemo(() => {
    const menuItems: Array<any> = [];
    const splitMenuItems: Array<any> = [];

    navData.forEach((value: any, key: number) => {
      if (value['is_header']) {
        setMenuSplitContainer((prev) => prev + 1); // <- move this logic elsewhere
      }
      if (key >= menuSplitContainer) {
        const val = {
          ...value,
          child_items: value.sub_items,
          is_child_item: !!value.sub_items,
        };
        splitMenuItems.push(val);
      } else {
        menuItems.push(value);
      }
    });

    if (menuSplitContainer === 6 && splitMenuItems.length > 0) {
      menuItems.push({
        id: 'more',
        label: 'More',
        icon: 'ri-briefcase-2-line',
        link: '/#',
        stateVariables: isMoreMenu,
        sub_items: splitMenuItems,
        click: (e: any) => {
          e.preventDefault();
          setIsMoreMenu((prev) => !prev);
        },
      });
    }

    return { menuItems };
  }, [navData, menuSplitContainer, isMoreMenu]);

  const path = props.router.location.pathname;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const initMenu = () => {
      const pathName = process.env.PUBLIC_URL + path;
      const ul = document.getElementById('navbar-nav') as HTMLElement;
      const items: any = ul.getElementsByTagName('a');
      const itemsArray = [...items];
      removeActivation(itemsArray);
      const matchingMenuItem = itemsArray.find((x) => x.pathname === pathName);
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
  }, [path, props.layoutType]);

  function activateParentDropdown(item: any) {
    item.classList.add('active');
    const parentCollapseDiv = item.closest('.collapse.menu-dropdown');
    if (parentCollapseDiv) {
      parentCollapseDiv.classList.add('show');
      parentCollapseDiv.parentElement.children[0].classList.add('active');
      parentCollapseDiv.parentElement.children[0].setAttribute(
        'aria-expanded',
        'true'
      );
      if (parentCollapseDiv.parentElement.closest('.collapse.menu-dropdown')) {
        parentCollapseDiv.parentElement
          .closest('.collapse')
          .classList.add('show');
        const parentElementDiv =
          parentCollapseDiv.parentElement.closest(
            '.collapse'
          ).previousElementSibling;
        if (parentElementDiv)
          if (parentElementDiv.closest('.collapse'))
            parentElementDiv.closest('.collapse').classList.add('show');
        parentElementDiv.classList.add('active');
        const parentElementSibling =
          parentElementDiv.parentElement.parentElement.parentElement
            .previousElementSibling;
        if (parentElementSibling) {
          parentElementSibling.classList.add('active');
        }
      }
      return false;
    }
    return false;
  }

  const removeActivation = (items: any) => {
    const actiItems = items.filter((x: any) => x.classList.contains('active'));

    actiItems.forEach((item: any) => {
      if (item.classList.contains('menu-link')) {
        if (!item.classList.contains('active')) {
          item.setAttribute('aria-expanded', 'false');
        }
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove('show');
        }
      }
      if (item.classList.contains('nav-link')) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove('show');
        }
        item.setAttribute('aria-expanded', 'false');
      }
      item.classList.remove('active');
    });
  };

  // const paddingAndMarginStyle = useMemo(() => 'px-2 mx-2', []);
  // const paddingAndMarginHeaderStyle = useMemo(() => 'px-2 mx-2', []);
  const frontIcon = useMemo(
    () => <i className="mdi mdi-chevron-right px-0 mx-0 d-flex"></i>,
    []
  );

  return (
    <React.Fragment>
      {(menuItems || []).map((item: any, key: number) => {
        return (
          <React.Fragment key={key}>
            {!item['is_header'] ? (
              item.sub_items ? (
                <li className="nav-item px-0 mx-0">
                  <Link
                    onClick={item.click}
                    className={`nav-link menu-link ${paddingAndMarginHeaderStyle}`}
                    to={item.link || '/#'}
                    data-bs-toggle="collapse"
                  >
                    <i className={item.icon}></i>{' '}
                    <span data-key="t-apps">{props.t(item.label)}</span>
                  </Link>
                  <Collapse
                    className="menu-dropdown"
                    isOpen={item.stateVariables}
                  >
                    <ul className={`nav nav-sm flex-column test`}>
                      {(item.sub_items || []).map(
                        (subItem: any, subKey: number) => (
                          <React.Fragment key={subKey}>
                            {!subItem.is_child_item ? (
                              !subItem.is_header ? (
                                <li className="nav-item">
                                  <Link
                                    to={subItem.link || '/#'}
                                    className="nav-link"
                                  >
                                    {frontIcon}
                                    {props.t(subItem.label)}
                                  </Link>
                                </li>
                              ) : (
                                <li className="nav-item">
                                  <div
                                    className={`${styles['sub-menu-title']}`}
                                  >
                                    {props.t(subItem.label.toUpperCase())}
                                  </div>
                                </li>
                              )
                            ) : (
                              <li className="nav-item">
                                <Link
                                  onClick={subItem.click}
                                  className="nav-link"
                                  to="/#"
                                  data-bs-toggle="collapse"
                                >
                                  {frontIcon}
                                  {props.t(subItem.label)}
                                </Link>
                                <Collapse
                                  className="menu-dropdown"
                                  isOpen={subItem.stateVariables}
                                >
                                  <ul className="nav nav-sm flex-column">
                                    {(subItem.child_items || []).map(
                                      (subChildItem: any, childKey: number) => (
                                        <li className="nav-item" key={childKey}>
                                          <Link
                                            to={subChildItem.link || '/#'}
                                            className="nav-link"
                                          >
                                            <i className="mdi mdi-chevron-right px-0 mx-0"></i>
                                            {props.t(subChildItem.label)}
                                          </Link>
                                        </li>
                                      )
                                    )}
                                  </ul>
                                </Collapse>
                              </li>
                            )}
                          </React.Fragment>
                        )
                      )}
                    </ul>
                  </Collapse>
                </li>
              ) : (
                <li className="nav-item px-0 mx-0">
                  <Link
                    className={`nav-link menu-link ${paddingAndMarginStyle}`}
                    to={item.link || '/#'}
                  >
                    <i className={item.icon}></i>{' '}
                    <span>{props.t(item.label)}</span>
                  </Link>
                </li>
              )
            ) : (
              <li className="menu-title px-0 mx-0">
                <span style={{ fontSize: '0.9375rem', fontWeight: 'bold' }}>
                  {props.t(item.label)}
                </span>
              </li>
            )}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};

HorizontalLayout.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(HorizontalLayout));
